export default "__VITE_ASSET__DlI07F07__"